import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
const initialState = {
  startDate: moment().subtract(2, "day").format("YYYY-MM-DD"),
  endDate: moment().format("YYYY-MM-DD"),
};

export const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    setStartDate: (state, action) => {
      console.log("state, action", state, action);
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      console.log("state, action", state, action);
      state.endDate = action.payload;
    },
  },
});

export const { setStartDate, setEndDate } = dateSlice.actions;

const dateSliceReducer = dateSlice.reducer;

export default dateSliceReducer;
